import React, { useState } from "react";
import { IconButton } from "@material-ui/core";
import CallEndIcon from "@material-ui/icons/CallEnd";
import Tooltip from "@material-ui/core/Tooltip";
import { useIntl } from "react-intl";
import RoomWrapper from "@vonage/video-express/dist/mp/room";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useStyles } from "./EndButton.style";
import { messages } from "./EndButton.messages";
import { RoutePath } from "../../../../../../Components/Routes/RoutePath";
import {
  Key,
  removeLocalStorageItem,
} from "../../../../../../Utils/LocalStorage";
import { meetingService } from "../../../../../../Providers/ServiceProvider/ServiceProvider";
import { useCustomerId } from "../../../../../../Providers/CustomerProvider/CustomerProvider";
import { useAuthenticatedUser } from "../../../../../../Providers/AuthenticatedUserProvider/AuthenticatedUserProvider";
import AlertDialog from "../../../../../../Components/Dialogs/AlertDialog/AlertDialog";
import { UserRoleType } from "../../../../../../generated/user-api";
import PermissionController from "../../../../../../Components/PermissionController/PermissionController";

interface Props {
  meetingId: string;
  room: RoomWrapper;
}

export default function EndButton(props: Props) {
  const { room, meetingId } = props;
  const intl = useIntl();
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const customerId = useCustomerId();
  const [authenticatedUser] = useAuthenticatedUser();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const redirectToBookingDetails = () => {
    history.push({
      pathname: RoutePath.BOOKING_HISTORY,
      search: `?meetingId=${meetingId}`,
      state: { loadFromMeetingSession: true },
    });
  };

  const handleEndMeeting = () => {
    room.leave().then(() => {
      removeLocalStorageItem(Key.OPENTOK_CLIENT_ID);
      if (customerId && authenticatedUser.user) {
        meetingService()
          .endMeetingSession({
            customerId,
            meetingId,
            meetingEndRequest: {
              userId: authenticatedUser.user.id,
            },
          })
          .then(() => {
            redirectToBookingDetails();
          })
          .catch(() =>
            enqueueSnackbar(intl.formatMessage(messages.generalError), {
              variant: "error",
            })
          );
      }
    });
  };

  return (
    <PermissionController allowedRoles={[UserRoleType.Staff]}>
      <AlertDialog
        open={isDialogOpen}
        title={intl.formatMessage(messages.dialogTitle)}
        content={intl.formatMessage(messages.dialogContent)}
        submitLabel={intl.formatMessage(messages.dialogSubmitButton)}
        cancelLabel={intl.formatMessage(messages.dialogCancelButton)}
        onSubmit={handleEndMeeting}
        onClose={() => setIsDialogOpen(false)}
      />
      <Tooltip
        title={intl.formatMessage(messages.endCallTooltip)}
        aria-label={intl.formatMessage(messages.endCallTooltip)}
      >
        <IconButton
          edge="start"
          aria-label={intl.formatMessage(messages.endCallTooltip)}
          onClick={() => setIsDialogOpen(true)}
          className={classes.toolbarButtons}
        >
          <CallEndIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </PermissionController>
  );
}
